// ¿Mercado Libre se puede ofrecer como destino de un lanzamiento? Sí si el backend lo tiene prendido
// y la persona lo ve (dev testers mientras no se lance para todos). La cuenta puede no estar
// conectada todavía: un lanzamiento se arma igual y se conecta antes de publicar
// (ADR-2026-09-30-lanzamiento-a-varias-tiendas).

import { useEffect, useState } from "react";
import { estadoDeMercadoLibre, EVENTO_CAMBIO_DE_MERCADOLIBRE } from "../lib/mercadoLibreConexion";

export function useMercadoLibreDisponible(brandId: string | null, activo = true): { disponible: boolean; conectada: boolean } {
  const [estado, setEstado] = useState({ disponible: false, conectada: false });
  useEffect(() => {
    if (!activo) return;
    let vivo = true;
    const leer = () =>
      void estadoDeMercadoLibre(brandId).then((e) => {
        if (vivo) setEstado({ disponible: e.disponible, conectada: e.disponible && e.conectada });
      });
    leer();
    window.addEventListener(EVENTO_CAMBIO_DE_MERCADOLIBRE, leer);
    return () => {
      vivo = false;
      window.removeEventListener(EVENTO_CAMBIO_DE_MERCADOLIBRE, leer);
    };
  }, [brandId, activo]);
  return estado;
}
